const APP_URL = 'https://app.myofade.com'

export default function HomePage() {
  return (
    <>
      <main id="main">
        <section className="hero" aria-labelledby="brand-name">
          <div className="hero-visual" aria-hidden="true">
            <div className="hero-figure">
              <img src="/logos/icon.svg" width={128} height={128} alt="" />
            </div>
          </div>
          <div className="hero-copy">
            <h1 id="brand-name" className="brand-hero">
              MyoFade
            </h1>
            <p className="hero-line">See what your muscles need.</p>
            <p className="hero-support">
              Scan gym machines, paint your body map red, and watch recovery fade back to grey -
              even when the gym Wi-Fi fails.
            </p>
            <div className="cta-row">
              <a className="btn-primary" href={APP_URL}>
                Launch MyoFade
              </a>
              <a className="btn-ghost" href="#how">
                How it works
              </a>
            </div>
          </div>
        </section>

        <section id="how" className="section" aria-labelledby="how-title">
          <h2 id="how-title">Three steps. Zero signal required.</h2>
          <p className="lead">
            MyoFade is a progressive web app that installs to your home screen and keeps working
            offline - built for basement racks and dead zones.
          </p>
          <ol className="how-steps">
            <li className="how-step">
              <h3>Scan or log</h3>
              <p>
                Point your camera at a machine QR code, or add a workout by hand. We tag the muscles
                that machine hits.
              </p>
            </li>
            <li className="how-step">
              <h3>Watch the fade</h3>
              <p>
                A rotatable 3D body map turns red by intensity - quads after leg extensions, outer
                glutes after hip abduction, and more as we add machines.
              </p>
            </li>
            <li className="how-step">
              <h3>Train the grey</h3>
              <p>
                Fatigue fades on a recovery curve guided by published rest windows (~48-72h for hard
                lower-body work). Grey means ready. Red means give it time. Exact half-lives and
                readiness cutoffs are a simplified model - details in the app.
              </p>
            </li>
          </ol>
        </section>

        <section className="section geo" aria-labelledby="geo-title">
          <h2 id="geo-title">Built for every gym floor</h2>
          <p className="lead">
            Whether you train in a big-box chain, a neighborhood studio, or a hotel fitness room,
            MyoFade keeps your recovery map local to your phone - no cloud account required.
          </p>
          <div className="geo-grid">
            <div className="geo-item">
              <strong>United States gyms</strong>
              <span>Works anywhere you can open a browser - from NYC lofts to Texas warehouse gyms.</span>
            </div>
            <div className="geo-item">
              <strong>Offline-first PWA</strong>
              <span>Install once; log sets when cellular drops between racks.</span>
            </div>
            <div className="geo-item">
              <strong>Machine QR ready</strong>
              <span>Matches the video QR codes already on many selectorized machines.</span>
            </div>
            <div className="geo-item">
              <strong>Privacy on-device</strong>
              <span>Workouts stay in your browser storage until you decide otherwise.</span>
            </div>
          </div>
        </section>

        <section className="section cta-band" aria-labelledby="cta-title">
          <h2 id="cta-title">
            Ready when you are. <span className="brand-inline">MyoFade</span>
          </h2>
          <p className="lead" style={{ marginInline: 'auto' }}>
            Open the app, add your first machine scan, and see the map light up.
          </p>
          <a className="btn-primary" href={APP_URL}>
            Go to the app
          </a>
        </section>
      </main>
    </>
  )
}
